import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  FormatDateToWord,
  CustomerSelect,
  TermsSelect,
  ItemSelect,
  SalesInvoiceOptionalCustomerSelect,
  SalesmanSelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import ExcelJS from 'exceljs';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';

export default function SalesOrderReport() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [company, setCompany] = useState(null);
  // const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [terms, setTerms] = useState("");
  const [salesman, setSalesman] = useState(null);
  const [invoice, setInvoice] = useState(null);

  const [customer, setCustomer] = useState(null);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);

  const openCustomerSelect = () => {
    setShowCustomerSelect(true)
  }
  const closeCustomerSelect = () => {
    setShowCustomerSelect(false)
  }

  const [item, setItem] = useState(null);
  const [showItemSelect, setShowItemSelect] = useState(false);

  const openItemSelect = () => {
    setShowItemSelect(true)
  }
  const closeItemSelect = () => {
    setShowItemSelect(false)
  }
//#endregion






//#region Generate
  const fetchReportData = useCallback(async () => {
    const body = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      customerId: customer ? customer?.customerId : null,
      itemCode: item ? item.itemCode : null,
      salesmanCode: salesman ? salesman.salesmanCode : null,
      terms: terms ? terms : null,
      documentId: invoice ? invoice?.id : null,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/sales-order`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo, customer, item, salesman, terms, invoice]);

  // PDF
  const generateSalesOrderByCustomerDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byCustomerDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_CUSTOMER_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);
      
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 12;
      let grandAmount = 0;

      // Helper to handle page breaks
      const addNewPage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      };

      for (const record of _data) {
        // Check space for Customer Name Header
        if (yPosition < bottomThreshold + 20) await addNewPage();

        currentPage.drawText(`${record.customerName ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 15;

        for (const order of record.orders) {
          for (const itemRow of order.items) {
            const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
            const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);

            // --- PAGE BREAK CHECK FOR ITEM ROW ---
            if (yPosition - rowHeight < bottomThreshold) {
              await addNewPage();
            }

            // Draw Row Data
            currentPage.drawText(FormatDateToMDY(order.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${order?.referenceNumber ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

            const truncatedSalesman = truncateText(record?.salesman ?? "", 50, calibriFont, 8);
            currentPage.drawText(truncatedSalesman, { x: 195, y: yPosition, size: 8, font: calibriFont });

            // Draw wrapped description
            for (let i = 0; i < descLines.length; i++) {
              currentPage.drawText(descLines[i], {
                x: 320,
                y: yPosition - i * lineHeight,
                size: 8,
                font: calibriFont,
              });
            }

            const qtyVal = parseFloat(itemRow.quantity) || 0;
            currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 443, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 485, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 525, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 567, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 628, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriFont });

            yPosition -= rowHeight + 5;
            grandAmount += itemRow.totalAmount || 0;
          }
        }

        // --- PAGE BREAK CHECK FOR CUSTOMER SUB-TOTAL ---
        // We check if there's enough space for the line (5px) and the text (15px)
        if (yPosition < bottomThreshold + 30) {
          await addNewPage();
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Customer Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(record.totalSalesAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; // Extra spacing between customers
      }

      // --- FOOTER SECTION (GRAND TOTAL) ---
      if (yPosition < 100) {
        await addNewPage();
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 700, y: yPosition, size: 9, font: calibriBold });

      // --- PAGINATION ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680,
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_CUSTOMER_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesOrderByCustomerSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byCustomerSummarized

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_CUSTOMER_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 73, y: 706, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 695, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 80;

      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        currentPage.drawText(`${record.customerName ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 10;

        for (const order of record.orders) {
          currentPage.drawText(FormatDateToWord(order.date), { x: 40, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${order.referenceNumber ?? ""}`, { x: 102, y: yPosition, size: 8, font: calibriFont });
          // Draw Row Data
          const truncatedSalesman = truncateText(record?.salesman ?? "", 120, calibriFont, 8);
          currentPage.drawText(truncatedSalesman, { x: 332, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${record.terms ?? ""}`, { x: 445, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(order.amount)}`, { x: 517, y: yPosition, size: 8, font: calibriFont });

          yPosition -= 10;

          grandAmount += order.amount || 0;
        }

        if (yPosition < bottomThreshold + 30) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Customer Sub-Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(record.totalSalesAmount)}`, { x: 517, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; // Extra spacing between customers
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 517, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 515, 
          y: 761,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_CUSTOMER_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesOrderByDateDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_DATE_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 505.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 494, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 450;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 20;

      let grandGrossTotal = 0;
      let grandDiscount = 0;
      let grandNetPrice = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        let subGrossTotal = 0; 
        let subDiscount = 0; 
        let subNetPrice = 0; 
        let subGrossVatable = 0; 
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        currentPage.drawText(`${FormatDateToMDY(record.date)} ${record.referenceNumber ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${record.customerName1 ?? ""}`, { x: 245, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 10

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 450;
          }

          // Draw Row Data

          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 40,
              y: yPosition - i * lineHeight,
              size: 8,
              font: calibriFont,
            });
          }

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 245, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 290, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 340, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 405, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 452, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 515, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 575, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 640, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriFont });

          const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
          yPosition -= rowHeight + 5;

          subGrossTotal += itemRow.unitPrice || 0;
          subDiscount += itemRow.totalDiscount || 0;
          subNetPrice += itemRow.netPrice || 0;
          subGrossVatable += itemRow.vaTableSales || 0;
          subVatable += itemRow.vaTableSales || 0;
          subVatAmount += itemRow.vat || 0;
          subAmount += itemRow.totalAmount || 0;

          grandGrossTotal += itemRow.unitPrice || 0;
          grandDiscount += itemRow.totalDiscount || 0;
          grandNetPrice += itemRow.netPrice || 0;
          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        }

          currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });

          currentPage.drawText(`Doc Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subGrossTotal)}`, { x: 340, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subDiscount)}`, { x: 405, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subNetPrice)}`, { x: 452, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subGrossVatable)}`, { x: 515, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 575, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatAmount)}`, { x: 640, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });

          yPosition -= 20;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 450;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossTotal)}`, { x: 340, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandDiscount)}`, { x: 405, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandNetPrice)}`, { x: 452, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 515, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 575, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 640, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_DATE_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };
  
  const generateSalesOrderByDateSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_DATE_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 505.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 494, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 450;
      const bottomThreshold = 80;
      const lineHeight = 10;

      let grandGrossTotal = 0;
      let grandDiscount = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 450;
        }

        currentPage.drawText(FormatDateToWord(record.date), { x: 40, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record.referenceNumber ?? ""}`, { x: 97, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record.customerName1 ?? ""}`, { x: 170, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record.terms ?? ""}`, { x: 267, y: yPosition, size: 8, font: calibriFont });
        const truncatedSalesman = truncateText(record?.salesman ?? "", 50, calibriFont, 8);
        currentPage.drawText(truncatedSalesman, { x: 322, y: yPosition, size: 8, font: calibriFont });

        currentPage.drawText(`${FormatValueToDecimal(record.subTotal)}`, { x: 417, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.discounts)}`, { x: 468, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 517, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 580, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.vat)}`, { x: 642, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 705, y: yPosition, size: 8, font: calibriFont });

        yPosition -= lineHeight;

        grandGrossTotal += record.subTotal || 0;
        grandDiscount += record.discounts || 0;
        grandGrossVatable += record.grossVatable || 0;
        grandVatable += record.grossVatable || 0;
        grandVatAmount += record.vat || 0;
        grandAmount += record.totalAmount || 0;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 450;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossTotal)}`, { x: 417, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandDiscount)}`, { x: 468, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 517, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 580, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 642, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 705, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_DATE_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesOrderByDocNoDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_DOC_NO_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 505.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 494, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 450;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 20;

      let grandGrossTotal = 0;
      let grandDiscount = 0;
      let grandNetPrice = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        let subGrossTotal = 0; 
        let subDiscount = 0; 
        let subNetPrice = 0; 
        let subGrossVatable = 0; 
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        currentPage.drawText(`${record.referenceNumber ?? ""} ${FormatDateToMDY(record.date)} ${record.customerName1 ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 10

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 450;
          }

          // Draw Row Data

          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 40,
              y: yPosition - i * lineHeight,
              size: 8,
              font: calibriFont,
            });
          }

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 245, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 290, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 340, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 405, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 452, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 515, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 575, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 640, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriFont });

          const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
          yPosition -= rowHeight + 5;

          subGrossTotal += itemRow.unitPrice || 0;
          subDiscount += itemRow.totalDiscount || 0;
          subNetPrice += itemRow.netPrice || 0;
          subGrossVatable += itemRow.vaTableSales || 0;
          subVatable += itemRow.vaTableSales || 0;
          subVatAmount += itemRow.vat || 0;
          subAmount += itemRow.totalAmount || 0;

          grandGrossTotal += itemRow.unitPrice || 0;
          grandDiscount += itemRow.totalDiscount || 0;
          grandNetPrice += itemRow.netPrice || 0;
          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        }

          currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });

          currentPage.drawText(`Doc Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subGrossTotal)}`, { x: 340, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subDiscount)}`, { x: 405, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subNetPrice)}`, { x: 452, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subGrossVatable)}`, { x: 515, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 575, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatAmount)}`, { x: 640, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });

          yPosition -= 20;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 450;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossTotal)}`, { x: 340, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandDiscount)}`, { x: 405, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandNetPrice)}`, { x: 452, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 515, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 575, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 640, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_DOC_NO_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesOrderByDocNoSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDocNoSummarized

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_DOC_NO_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 73, y: 706, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 695, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 80;

      let grandAmount = 0;

      for (const record of _data) {
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }
        
        currentPage.drawText(FormatDateToWord(record.date), { x: 40, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record.referenceNumber ?? ""}`, { x: 102, y: yPosition, size: 8, font: calibriFont });
        // Draw Row Data
        const truncatedCustomer = truncateText(record?.customerName1 ?? "", 120, calibriFont, 8);
        currentPage.drawText(truncatedCustomer, { x: 240, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record.terms ?? ""}`, { x: 340, y: yPosition, size: 8, font: calibriFont });
        const truncatedSalesman = truncateText(record?.salesman ?? "", 120, calibriFont, 8);
        currentPage.drawText(truncatedSalesman, { x: 400, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 517, y: yPosition, size: 8, font: calibriFont });

        yPosition -= 10;

        grandAmount += record.amount || 0;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 517, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 515, 
          y: 761,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_DOC_NO_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesOrderByItemDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byItemDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_ITEM_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);
      
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandAmount = 0;

      // Helper to handle page breaks
      const addNewPage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      };

      for (const record of _data) {
        // Check space for Customer Name Header
        if (yPosition < bottomThreshold + 20) await addNewPage();

        currentPage.drawText(`${record.description ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 15;

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK FOR ITEM ROW ---
          if (yPosition < bottomThreshold) {
            await addNewPage();
          }

          // Draw Row Data
          currentPage.drawText(FormatDateToMDY(itemRow.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow?.docNo ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

          const truncatedCustomer = truncateText(itemRow?.customer ?? "", 50, calibriFont, 8);
          currentPage.drawText(truncatedCustomer, { x: 195, y: yPosition, size: 8, font: calibriFont });

          const truncatedSalesman = truncateText(itemRow?.salesman ?? "", 50, calibriFont, 8);
          currentPage.drawText(truncatedSalesman, { x: 300, y: yPosition, size: 8, font: calibriFont });

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 420, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 457, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.unitPrice)}`, { x: 490, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 542, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 579, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 630, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriFont });

          yPosition -= lineHeight;
          grandAmount += itemRow.totalAmount || 0;
        }

        // --- PAGE BREAK CHECK FOR CUSTOMER SUB-TOTAL ---
        // We check if there's enough space for the line (5px) and the text (15px)
        if (yPosition < bottomThreshold + 30) {
          await addNewPage();
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Item Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
        const qtyVal = parseFloat(record.totalQuantity) || 0;
        currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 420, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record.uomName ?? ""}`, { x: 457, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; // Extra spacing between customers
      }

      // --- FOOTER SECTION (GRAND TOTAL) ---
      if (yPosition < 100) {
        await addNewPage();
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 690, y: yPosition, size: 9, font: calibriBold });

      // --- PAGINATION ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680,
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_ITEM_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesOrderByItemSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byItemDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_ORDER_BY_ITEM_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 73, y: 706, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 695, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 80;

      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        currentPage.drawText(`${record.description ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });

        const qtyVal = parseFloat(record.totalQuantity) || 0;
        currentPage.drawText(`${FormatValueToDecimal(qtyVal)} ${record.uomName ?? ""}`, { x: 317, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 490, y: yPosition, size: 8, font: calibriFont });

        yPosition -= 10;

        grandAmount += record.totalAmount || 0;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 490, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 515, 
          y: 761,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_ORDER_BY_ITEM_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  //Excel
  const exportSalesOrderByCustomerDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byCustomerDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Detailed');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY CUSTOMER (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Ref. No.',
        'Salesman',
        'Item',
        'Qty',
        'UOM',
        'Disc %',
        'Discount',
        'Net Price',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // Add a row for the Customer Name (Header for the section)
        const customerHeaderRow = worksheet.addRow([record.customerName]);
        customerHeaderRow.font = { bold: true };
        customerHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        
        // Merge customer name across a few cells for better look
        worksheet.mergeCells(`A${customerHeaderRow.number}:D${customerHeaderRow.number}`);

        record.orders.forEach(order => {
          order.items.forEach(itemRow => {
            const row = worksheet.addRow([
              FormatDateToMDY(order.date),
              order.referenceNumber?.toString(),
              "",
              record.salesman,
              itemRow.itemDescription,
              parseFloat(itemRow.quantity || 0),
              itemRow.uomName,
              parseFloat(itemRow.discountPercent || 0) / 100, // Excel handles % as decimals
              parseFloat(itemRow.totalDiscount || 0),
              parseFloat(itemRow.netPrice || 0),
              parseFloat(itemRow.totalAmount || 0),
            ]);

            // Apply Number Formatting
            const currencyCols = [8, 9, 10]; 
            currencyCols.forEach(colIndex => {
              row.getCell(colIndex).numFmt = '#,##0.00';
            });
            row.getCell(5).numFmt = '#,##0.00'; // Qty
            row.getCell(7).numFmt = '0.00%';    // Discount %
          });
        });

        // 6. Add Customer Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Sub-Total for ${record.customerName}:`, '', '', '', '', '', '', '', '', '',
          parseFloat(record.totalSalesAmount || 0)
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(11).numFmt = '#,##0.00';
        subTotalRow.getCell(11).border = { top: { style: 'thin' } };
        
        grandAmount += parseFloat(record.totalSalesAmount || 0);
        worksheet.addRow([]); // Blank line after each customer section
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(11).numFmt = '#,##0.00';
      grandTotalRow.getCell(11).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(11).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 15 }, // Doc No
        { width: 15 }, // Ref No
        { width: 20 }, // Salesman
        { width: 40 }, // Item Description
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 10 }, // Disc %
        { width: 15 }, // Total Disc
        { width: 15 }, // Net Price
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Detailed_${new Date().getTime()}.xlsx`;
      
      // Using standard link download method
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesOrderByCustomerSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byCustomerSummarized;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Summarized');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY CUSTOMER (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Ref. No.',
        'P.O. No.',
        'Salesman',
        'Terms',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // Add Customer Name Header Row
        const customerHeaderRow = worksheet.addRow([record.customerName]);
        customerHeaderRow.font = { bold: true };
        customerHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        // Merge across the first 4 columns for the name
        worksheet.mergeCells(`A${customerHeaderRow.number}:D${customerHeaderRow.number}`);

        record.orders.forEach(order => {
          const row = worksheet.addRow([
            FormatDateToMDY(order.date),
            order.referenceNumber?.toString(),
            "",
            "",
            record.salesman,
            record.terms,
            parseFloat(order.amount || 0)
          ]);

          // Format Amount column
          row.getCell(7).numFmt = '#,##0.00';
          grandAmount += parseFloat(order.amount || 0);
        });

        // 6. Add Customer Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Sub-Total for ${record.customerName}:`, '', '', '', '', '',
          parseFloat(record.totalSalesAmount || 0)
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(7).numFmt = '#,##0.00';
        subTotalRow.getCell(7).border = { top: { style: 'thin' } };
        
        worksheet.addRow([]); // Space after each customer section
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(7).numFmt = '#,##0.00';
      grandTotalRow.getCell(7).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow
      grandTotalRow.getCell(7).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 15 }, // Date
        { width: 20 }, // Reference No
        { width: 30 }, // Salesman
        { width: 15 }, // Terms
        { width: 20 }, // Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesOrderByDateDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byDateDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Date Detailed');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY DATE (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Item',
        'Qty',
        'UOM',
        'Gross Price',
        'Discount',
        'Net Price',
        'Gross VATable',
        'VATable Sales',
        'VAT Amount',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Initialize Grand Totals
      let grandGrossTotal = 0;
      let grandDiscount = 0;
      let grandNetPrice = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      // 6. Add Data Rows
      _data.forEach(record => {
        // Document Header Row (Date, Ref, and Customer Name)
        const docHeader = worksheet.addRow([
          `${FormatDateToMDY(record.date)} | ${record.referenceNumber ?? ""} | ${record.customerName1 ?? ""}`
        ]);
        docHeader.font = { bold: true };
        docHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${docHeader.number}:J${docHeader.number}`);

        let subGrossTotal = 0; 
        let subDiscount = 0; 
        let subNetPrice = 0; 
        let subGrossVatable = 0; 
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            itemRow.itemDescription,
            parseFloat(itemRow.quantity || 0),
            itemRow.uomName,
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.netPrice || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vat || 0),
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Format Number Columns
          [2, 4, 5, 6, 7, 8, 9, 10].forEach(colIndex => {
            row.getCell(colIndex).numFmt = '#,##0.00';
          });

          // Accumulate Sub Totals
          subGrossTotal += itemRow.unitPrice || 0;
          subDiscount += itemRow.totalDiscount || 0;
          subNetPrice += itemRow.netPrice || 0;
          subGrossVatable += itemRow.vaTableSales || 0;
          subVatable += itemRow.vaTableSales || 0;
          subVatAmount += itemRow.vat || 0;
          subAmount += itemRow.totalAmount || 0;
        });

        // 7. Add Doc Total Row
        const docTotalRow = worksheet.addRow([
          'Doc Total:', '', '',
          subGrossTotal,
          subDiscount,
          subNetPrice,
          subGrossVatable,
          subVatable,
          subVatAmount,
          subAmount
        ]);
        docTotalRow.font = { bold: true, italic: true };
        [4, 5, 6, 7, 8, 9, 10].forEach(idx => {
          docTotalRow.getCell(idx).numFmt = '#,##0.00';
          docTotalRow.getCell(idx).border = { top: { style: 'thin' } };
        });

        // Accumulate Grand Totals
        grandGrossTotal += subGrossTotal;
        grandDiscount += subDiscount;
        grandNetPrice += subNetPrice;
        grandGrossVatable += subGrossVatable;
        grandVatable += subVatable;
        grandVatAmount += subVatAmount;
        grandAmount += subAmount;

        worksheet.addRow([]); // Gap between documents
      });

      // 8. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '',
        grandGrossTotal,
        grandDiscount,
        grandNetPrice,
        grandGrossVatable,
        grandVatable,
        grandVatAmount,
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      [4, 5, 6, 7, 8, 9, 10].forEach(idx => {
        grandTotalRow.getCell(idx).numFmt = '#,##0.00';
        grandTotalRow.getCell(idx).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
        grandTotalRow.getCell(idx).border = { top: { style: 'thin', color: {argb: '000000'} }, bottom: { style: 'double' } };
      });

      // 9. Adjust Column Widths
      worksheet.columns = [
        { width: 40 }, // Item Description
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 15 }, // Unit Price
        { width: 15 }, // Total Discount
        { width: 15 }, // Net Price
        { width: 15 }, // Gross VATable
        { width: 15 }, // VATable Sales
        { width: 12 }, // VAT
        { width: 18 }, // Total Amount
      ];

      // 10. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Date_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesOrderByDateSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      // Using byDateDetailed as per your PDF logic for summarized data
      const _data = allData?.byDateDetailed; 

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Summarized');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY DATE (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Customer',
        'Terms',
        'Salesman',
        'Gross',
        'Discounts',
        'Gross VATable',
        'VATable Sales',
        'VAT',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Initialize Grand Totals
      let grandGrossTotal = 0;
      let grandDiscount = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      // 6. Add Data Rows
      _data.forEach(record => {
        const row = worksheet.addRow([
          FormatDateToMDY(record.date),
          record.referenceNumber?.toString(),
          record.customerName1,
          record.terms,
          record.salesman,
          parseFloat(record.subTotal || 0),
          parseFloat(record.discounts || 0),
          parseFloat(record.grossVatable || 0),
          parseFloat(record.grossVatable || 0), // VATable Sales
          parseFloat(record.vat || 0),
          parseFloat(record.totalAmount || 0)
        ]);

        // Apply Number Formatting to currency columns (6 to 11)
        [6, 7, 8, 9, 10, 11].forEach(colIndex => {
          row.getCell(colIndex).numFmt = '#,##0.00';
        });

        // Accumulate Grand Totals
        grandGrossTotal += record.subTotal || 0;
        grandDiscount += record.discounts || 0;
        grandGrossVatable += record.grossVatable || 0;
        grandVatable += record.grossVatable || 0;
        grandVatAmount += record.vat || 0;
        grandAmount += record.totalAmount || 0;
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '',
        grandGrossTotal,
        grandDiscount,
        grandGrossVatable,
        grandVatable,
        grandVatAmount,
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      
      // Style Total Cells
      [6, 7, 8, 9, 10, 11].forEach(idx => {
        const cell = grandTotalRow.getCell(idx);
        cell.numFmt = '#,##0.00';
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow
        cell.border = { 
            top: { style: 'thin' }, 
            bottom: { style: 'double' } 
        };
      });

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 15 }, // Ref No
        { width: 30 }, // Customer Name
        { width: 12 }, // Terms
        { width: 20 }, // Salesman
        { width: 15 }, // Sub-Total
        { width: 15 }, // Discounts
        { width: 15 }, // Gross VATable
        { width: 15 }, // VATable Sales
        { width: 12 }, // VAT
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Date_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesOrderByDocNoDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      // Using byDateDetailed as per your PDF logic
      const _data = allData?.byDateDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Doc Detailed');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY DOCUMENT NO. (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Item',
        'Qty',
        'UOM',
        'Gross Price',
        'Discount',
        'Net Price',
        'Gross VATable',
        'VATable Sales',
        'VAT',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Initialize Grand Totals
      let grandGrossTotal = 0;
      let grandDiscount = 0;
      let grandNetPrice = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      // 6. Add Data Rows
      _data.forEach(record => {
        // Doc Header Row (Reference No + Date + Customer)
        const docHeader = worksheet.addRow([
          `${record.referenceNumber ?? ""} | ${FormatDateToMDY(record.date)} | ${record.customerName1 ?? ""}`
        ]);
        docHeader.font = { bold: true };
        docHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E8E8E8' } };
        worksheet.mergeCells(`A${docHeader.number}:J${docHeader.number}`);

        let subGrossTotal = 0; 
        let subDiscount = 0; 
        let subNetPrice = 0; 
        let subGrossVatable = 0; 
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            itemRow.itemDescription,
            parseFloat(itemRow.quantity || 0),
            itemRow.uomName,
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.netPrice || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vat || 0),
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Apply number formatting
          [2, 4, 5, 6, 7, 8, 9, 10].forEach(colIndex => {
            row.getCell(colIndex).numFmt = '#,##0.00';
          });

          // Sub totals accumulation
          subGrossTotal += itemRow.unitPrice || 0;
          subDiscount += itemRow.totalDiscount || 0;
          subNetPrice += itemRow.netPrice || 0;
          subGrossVatable += itemRow.vaTableSales || 0;
          subVatable += itemRow.vaTableSales || 0;
          subVatAmount += itemRow.vat || 0;
          subAmount += itemRow.totalAmount || 0;
        });

        // 7. Add Doc Total Row
        const docTotalRow = worksheet.addRow([
          'Doc Total:', '', '',
          subGrossTotal,
          subDiscount,
          subNetPrice,
          subGrossVatable,
          subVatable,
          subVatAmount,
          subAmount
        ]);
        docTotalRow.font = { bold: true, italic: true };
        
        // Formatting for Doc Total row
        [4, 5, 6, 7, 8, 9, 10].forEach(idx => {
          docTotalRow.getCell(idx).numFmt = '#,##0.00';
          docTotalRow.getCell(idx).border = { top: { style: 'thin' } };
        });

        // Accumulate to Grand Totals
        grandGrossTotal += subGrossTotal;
        grandDiscount += subDiscount;
        grandNetPrice += subNetPrice;
        grandGrossVatable += subGrossVatable;
        grandVatable += subVatable;
        grandVatAmount += subVatAmount;
        grandAmount += subAmount;

        worksheet.addRow([]); // Blank line after each document group
      });

      // 8. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '',
        grandGrossTotal,
        grandDiscount,
        grandNetPrice,
        grandGrossVatable,
        grandVatable,
        grandVatAmount,
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      
      [4, 5, 6, 7, 8, 9, 10].forEach(idx => {
        const cell = grandTotalRow.getCell(idx);
        cell.numFmt = '#,##0.00';
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow
        cell.border = { 
            top: { style: 'thin' }, 
            bottom: { style: 'double' } 
        };
      });

      // 9. Adjust Column Widths
      worksheet.columns = [
        { width: 40 }, // Description
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 15 }, // Unit Price
        { width: 15 }, // Total Disc
        { width: 15 }, // Net Price
        { width: 15 }, // Gross VATable
        { width: 15 }, // VATable Sales
        { width: 12 }, // VAT
        { width: 18 }, // Total Amount
      ];

      // 10. Generate and Download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Doc_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesOrderByDocNoSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byDocNoSummarized;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Summarized');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY DOCUMENT NO. (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Ref. No',
        'Customer Name',
        'Terms',
        'Salesman',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        const row = worksheet.addRow([
          FormatDateToMDY(record.date),
          record.referenceNumber?.toString(),
          "",
          record.customerName1,
          record.terms,
          record.salesman,
          parseFloat(record.amount || 0)
        ]);

        // Apply Number Formatting to Amount column
        row.getCell(7).numFmt = '#,##0.00';

        // Accumulate Grand Total
        grandAmount += parseFloat(record.amount || 0);
      });

      // 6. Add Grand Totals Footer
      worksheet.addRow([]); // Space before footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      
      // Style the Total Cell
      const totalCell = grandTotalRow.getCell(7);
      totalCell.numFmt = '#,##0.00';
      totalCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow
      totalCell.border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 7. Adjust Column Widths
      worksheet.columns = [
        { width: 15 }, // Date
        { width: 15 }, // Reference No.
        { width: 15 }, // Reference No.
        { width: 35 }, // Customer Name
        { width: 12 }, // Terms
        { width: 25 }, // Salesman
        { width: 18 }, // Amount
      ];

      // 8. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Doc_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesOrderByItemDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byItemDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Item Detailed');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY ITEM (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc No.',
        'Ref. No.',
        'Customer',
        'Salesman',
        'Qty',
        'UOM',
        'Gross',
        'Disc %',
        'Disc. Amt.',
        'Net Price',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // ITEM GROUP HEADER (Item Description)
        const itemHeaderRow = worksheet.addRow([record.description]);
        itemHeaderRow.font = { bold: true };
        itemHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${itemHeaderRow.number}:D${itemHeaderRow.number}`);

        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            FormatDateToMDY(itemRow.date),
            itemRow.docNo?.toString(),
            "",
            itemRow.customer,
            itemRow.salesman,
            parseFloat(itemRow.quantity || 0),
            itemRow.uomName,
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.discountPercent || 0) / 100, // Excel handles % as decimals
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.netPrice || 0),
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Apply Number Formatting
          [5, 7, 9, 10, 11].forEach(colIndex => {
            row.getCell(colIndex).numFmt = '#,##0.00';
          });
          row.getCell(8).numFmt = '0.00%'; // Disc % column
        });

        // 6. ITEM SUB-TOTAL
        const subTotalRow = worksheet.addRow([
          'Item Sub-Total:', '', '', '', '',
          parseFloat(record.totalQuantity || 0),
          record.uomName,
          '', '', '', '',
          parseFloat(record.totalAmount || 0)
        ]);

        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(6).numFmt = '#,##0.00';
        subTotalRow.getCell(12).numFmt = '#,##0.00';
        
        // Add a top border to subtotal numbers
        subTotalRow.getCell(6).border = { top: { style: 'thin' } };
        subTotalRow.getCell(12).border = { top: { style: 'thin' } };

        grandAmount += parseFloat(record.totalAmount || 0);
        worksheet.addRow([]); // Blank line between item groups
      });

      // 7. GRAND TOTAL FOOTER
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      const totalCell = grandTotalRow.getCell(12);
      totalCell.numFmt = '#,##0.00';
      totalCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow
      totalCell.border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 15 }, // Doc No
        { width: 30 }, // Customer
        { width: 20 }, // Salesman
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 12 }, // Unit Price
        { width: 10 }, // Disc %
        { width: 12 }, // Total Disc
        { width: 12 }, // Net Price
        { width: 15 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Item_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesOrderByItemSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      // Using byItemDetailed as per your PDF logic
      const _data = allData?.byItemDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Order Item Summarized');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES ORDER BY ITEM (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Item Description',
        'Total Quantity',
        'UOM',
        'Total Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        const row = worksheet.addRow([
          record.description ?? "",
          parseFloat(record.totalQuantity || 0),
          record.uomName ?? "",
          parseFloat(record.totalAmount || 0)
        ]);

        // Apply Number Formatting
        row.getCell(2).numFmt = '#,##0.00';
        row.getCell(4).numFmt = '#,##0.00';

        // Accumulate Grand Total
        grandAmount += parseFloat(record.totalAmount || 0);
      });

      // 6. Add Grand Totals Footer
      worksheet.addRow([]); // Blank line before footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', 
        '', 
        '', 
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      
      // Style the Total Cell
      const totalCell = grandTotalRow.getCell(4);
      totalCell.numFmt = '#,##0.00';
      totalCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow
      totalCell.border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 7. Adjust Column Widths
      worksheet.columns = [
        { width: 50 }, // Item Description
        { width: 15 }, // Total Quantity
        { width: 10 }, // UOM
        { width: 20 }, // Total Amount
      ];

      // 8. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Sales_Order_Item_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasSalesOrderReport) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Sales Order Report`}
            </h2>
            <p className="text-gray-500 mt-1">Report of all Sales Orders.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Customer 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Customer"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                readOnly
              />
              {!customer ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Item 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Item"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${item ? `${item?.itemCode} - ${item?.itemDescription}` : ""}`}
                readOnly
              />
              {!item ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openItemSelect}>
                  <SearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setItem(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Salesman 
            </label>
            <SalesmanSelect data={salesman} setData={setSalesman} customer={customer} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Terms
            </label>
            <TermsSelect data={terms} setData={setTerms} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Document No.
            </label>
            <SalesInvoiceOptionalCustomerSelect data={invoice} setData={setInvoice} isEditable={true} customerId={customer ? customer?.customerId : "All"}/>
          </div>

        </div>

        <div className="mt-5 p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 mb-6 px-2">Generate Sales Orders</h2>

          {/* Header Row - Hidden on Mobile */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-4 mb-2 text-xs font-black uppercase tracking-widest text-gray-400">
            <div className="col-span-2">Report Category</div>
            <div className="col-span-5">PDF Reports</div>
            <div className="col-span-5 border-l border-gray-100">Excel Reports</div>
          </div>

          <div className="space-y-3">
            {[
              { 
                label: "By Customer", 
                pdf_detailed: generateSalesOrderByCustomerDetailedHandleClick, 
                pdf_summarized: generateSalesOrderByCustomerSummarizedHandleClick, 
                excel_detailed: exportSalesOrderByCustomerDetailedExcel, // Replace with your Excel function
                excel_summarized: exportSalesOrderByCustomerSummarizedExcel, // Replace with your Excel function
              },
              { 
                label: "By Date", 
                pdf_detailed: generateSalesOrderByDateDetailedHandleClick, 
                pdf_summarized: generateSalesOrderByDateSummarizedHandleClick,
                excel_detailed: exportSalesOrderByDateDetailedExcel, 
                excel_summarized: exportSalesOrderByDateSummarizedExcel 
              },
              { 
                label: "By Doc No", 
                pdf_detailed: generateSalesOrderByDocNoDetailedHandleClick, 
                pdf_summarized: generateSalesOrderByDocNoSummarizedHandleClick,
                excel_detailed: exportSalesOrderByDocNoDetailedExcel, 
                excel_summarized: exportSalesOrderByDocNoSummarizedExcel
              },
              { 
                label: "By Item", 
                pdf_detailed: generateSalesOrderByItemDetailedHandleClick, 
                pdf_summarized: generateSalesOrderByItemSummarizedHandleClick,
                excel_detailed: exportSalesOrderByItemDetailedExcel, 
                excel_summarized: exportSalesOrderByItemSummarizedExcel
              },
            ].map((group, idx) => (
              <div key={idx} className="grid grid-cols-1 md:grid-cols-12 items-center gap-4 p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors">
                
                {/* Label */}
                <div className="col-span-2">
                  <span className="text-sm font-bold text-gray-700">{group.label}</span>
                </div>

                {/* PDF Column */}
                <div className="col-span-5 flex flex-wrap gap-2">
                  <button 
                    onClick={group.pdf_detailed} 
                    className="flex items-center gap-2 bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100 transition-all active:scale-95"
                    title="Download PDF Detailed"
                  >
                    <RestartAltIcon sx={{ fontSize: 16 }} /> Detailed
                  </button>
                  
                  <button 
                    onClick={group.pdf_summarized} 
                    className="flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-50 transition-all active:scale-95"
                  >
                    Summarized
                  </button>

                  {group.pdf_extra && (
                    <button 
                      onClick={group.pdf_extra} 
                      className="flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-blue-100 transition-all active:scale-95"
                    >
                      Summarized w/ %
                    </button>
                  )}
                </div>

                {/* Excel Column */}
                <div className="col-span-5 flex flex-wrap gap-2 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0">
                  <button 
                    onClick={group.excel_detailed} 
                    className="flex items-center gap-2 bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-700 shadow-sm transition-all active:scale-95"
                  >
                    Excel Detailed
                  </button>
                  
                  <button 
                    onClick={group.excel_summarized} 
                    className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                  >
                    Excel Summ.
                  </button>
                  
                  
                  { group.excel_extra &&
                    <button 
                      onClick={group.excel_extra} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ. w/ %
                    </button>
                  }
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>
      
      <CustomerSelect 
        visible={showCustomerSelect} 
        onClose={closeCustomerSelect}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />
      
      <ItemSelect 
        visible={showItemSelect} 
        onClose={closeItemSelect}
        modalName={"Select Item"}
        data={item} setData={setItem}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}